import * as React from 'react';
import update from 'immutability-helper';
import { Popup, Icon, SemanticCOLORS, SemanticICONS } from 'semantic-ui-react';
import { getI18n } from 'services/i18n-service';
import { RetryErroneousItemAction } from 'components/main/actions';
import { store } from 'pages/app/store';
import { translations } from 'types/translations';
import { OperationItem } from 'types/operation-item';

import './styles.css';

export interface Props {
  iconName: SemanticICONS;
  iconColor: SemanticCOLORS;
  message: string;
  operationItem: OperationItem;
}

interface State {
  isPopupOpen: boolean;
}

export class StatusIconPopup extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      isPopupOpen: false
    };
  }

  handlePopupOpen = () => {
    this.setState(update(this.state, {
      isPopupOpen: { $set: true }
    }));
  }

  handlePopupClose = () => {
    this.setState(update(this.state, {
      isPopupOpen: { $set: false }
    }));
  }

  render() {
    const i18n = getI18n();
    const icon = <Icon className="status-cell-content" name={this.props.iconName} color={this.props.iconColor} />;

    return (
      <Popup trigger={icon} open={this.state.isPopupOpen} onOpen={this.handlePopupOpen} onClose={this.handlePopupClose}
        className="status-cell-content-popup"
        hoverable={true}>
        <span className="content">{this.props.message}</span>
        <span className="retry-link" onClick={() => this.retryErroneousItem(this.props.operationItem)}>
          {i18n.t(translations.ClickTryAgain)}
        </span>
      </Popup>
    );
  }

  async retryErroneousItem(item: OperationItem) {
    this.handlePopupClose();
    await store.dispatch(new RetryErroneousItemAction(item));
  }
}


// WEBPACK FOOTER //
// ./src/components/operation-grid/cells/status/status-icon-popup.tsx